/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateInstructionDto
 */
export interface GenerateInstructionDto {
    /**
     * Patient ID (required - for associating instruction with a patient)
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    patientId: string;
    /**
     * Treatment plan ID (required - for associating instruction with a treatment plan)
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    treatmentPlanId: string;
    /**
     * Language of the instruction
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    language: string;
    /**
     * Patient comments
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    patientComments: string;
    /**
     * Additional comments
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    additionalComments: string;
}

/**
 * Check if a given object implements the GenerateInstructionDto interface.
 */
export function instanceOfGenerateInstructionDto(value: object): value is GenerateInstructionDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('treatmentPlanId' in value) || value['treatmentPlanId'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('patientComments' in value) || value['patientComments'] === undefined) return false;
    if (!('additionalComments' in value) || value['additionalComments'] === undefined) return false;
    return true;
}

export function GenerateInstructionDtoFromJSON(json: any): GenerateInstructionDto {
    return GenerateInstructionDtoFromJSONTyped(json, false);
}

export function GenerateInstructionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInstructionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'treatmentPlanId': json['treatmentPlanId'],
        'language': json['language'],
        'patientComments': json['patientComments'],
        'additionalComments': json['additionalComments'],
    };
}

export function GenerateInstructionDtoToJSON(json: any): GenerateInstructionDto {
    return GenerateInstructionDtoToJSONTyped(json, false);
}

export function GenerateInstructionDtoToJSONTyped(value?: GenerateInstructionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'treatmentPlanId': value['treatmentPlanId'],
        'language': value['language'],
        'patientComments': value['patientComments'],
        'additionalComments': value['additionalComments'],
    };
}

